import {
  classRegistry,
  ObjectEvents,
  TClassProperties,
  TOptions,
  Rect,
  SerializedRectProps,
} from "fabric";

interface UniqueCustomProps {
  name: string;
}

export interface SerializedCustomProps
  extends SerializedRectProps,
    UniqueCustomProps {}

export interface CustomProps extends SerializedRectProps, UniqueCustomProps {}

export default class RectPlus<
  Props extends TOptions<CustomProps> = Partial<CustomProps>,
  SProps extends SerializedCustomProps = SerializedCustomProps,
  EventSpec extends ObjectEvents = ObjectEvents,
> extends Rect<Props, SProps, EventSpec> {
  static type = "rect";
  declare name: string;

  toObject<
    T extends Omit<Props & TClassProperties<this>, keyof SProps>,
    K extends keyof T = never,
  >(propertiesToInclude: K[] = []): Pick<T, K> & SProps {
    return super.toObject([...propertiesToInclude, "name"]);
  }
}
// to make possible restoring from serialization
classRegistry.setClass(RectPlus, "rect");
// to make PathPlus connected to svg Path element
classRegistry.setSVGClass(RectPlus, "rect");
